import { defineStore } from 'pinia';
import { SHOPS_API } from '@/api/shopApi';

export const useShopStore = defineStore('shop', {
    state: () => ({
        currentShop: null,
        loading: false,
        error: null,
    }),

    getters: {
        hasShop: (state) => !!state.currentShop,
        shopName: (state) => state.currentShop?.shop_name || '',
        shopId: (state) => state.currentShop?.shop_id || null,
        shopLogo: (state) => state.currentShop?.thumbnail_url || null,
    },

    actions: {
        clearError() {
            this.error = null;
        },

        async fetchShopDetails(shopId) {
            if (!shopId) {
                this.error = 'Shop ID is required';
                return;
            }

            this.loading = true;
            this.error = null;

            try {
                const response = await SHOPS_API.fetchShopDetailsApi(shopId);
                
                if (response?.success) {
                    this.currentShop = response.data;
                } else {
                    throw new Error(response?.message || 'Failed to fetch shop details');
                }
            } catch (error) {
                this.error = error.message || 'Failed to fetch shop details';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        async updateShopStore(shopData) {
            this.loading = true;
            this.error = null;
            
            try {
                const response = await SHOPS_API.updateShopApi(shopData);
                
                if (!response?.success) {
                    throw new Error(response?.message || 'Failed to update shop');
                }
                
                if (response?.success && response?.data) {
                    this.currentShop = response.data;
                }
                
                return response;
            } catch (error) {
                this.error = error.message || 'Failed to update shop';
                throw error;
            } finally {
                this.loading = false;
            }
        }
    }
});